export default __webpack_public_path__ + "static/media/enter-details.32335705.svg";